import reactDOM from "react-dom/client"
import App from "./App.jsx"
import { CsvDataProvider } from "./components/Context.jsx"

reactDOM.createRoot(document.getElementById('root')).render(
    <CsvDataProvider>
      <App />
    </CsvDataProvider>
  );